import { SET_PURCHASE_LICENSE_FLOW_GRANT_STATUS } from './globalPolicyDecisionRequestActionTypes';

const initialState = {
  purchaseLicenseFlowGrantStatus: null,
};

export const globalPolicyDecisionRequestState = (
  state = initialState,
  action,
) => {
  const updatedState = { ...state };

  switch (action.type) {
    case SET_PURCHASE_LICENSE_FLOW_GRANT_STATUS:
      updatedState.purchaseLicenseFlowGrantStatus = action.payload;
      return updatedState;
    default:
      return state;
  }
};
